import React, { useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import "animate.css";

const NoteForm = ({ note, updateNote, close, project, user }) => {
  const [editingNote, setEditingNote] = useState(note);
  const [saving, setSaving] = useState(false);
  const [hide, setHide] = useState(false);

  const handleSubmit = () => {
    setSaving(true);

    if (!project) {
      let method = "post";
      let url = `/notes.json`;

    if (editingNote.id) {
      method = "patch";
      url = `/notes/${note.id}.json`;
    }

    HTTP[method](url, {
      user_id: note.user_id,
      note: editingNote,
    })
      .then(() => {
        updateNote();
        setTimeout(() => {
          setSaving(false);
          Alert.show("notice", "Notes saved!");
          handleClose();
        }, 1000);
      })
      .catch(() => {
        Alert.show("error", "Could not save. Try again or refresh.");
        setSaving(false);
      });
      return
    }

    let method = "post";
    let url = `/project/notes.json`;

    if (editingNote.id) {
      method = "patch";
      url = `/project/notes.json`;
    }

    HTTP[method](url, {
      project_id: note.user_id,
      note: editingNote,
      user_type: user.user_type
    })
      .then(() => {
        updateNote();
        setTimeout(() => {
          setSaving(false);
          Alert.show("notice", "Notes saved!");
          handleClose();
        }, 1000);
      })
      .catch(() => {
        Alert.show("error", "Could not save. Try again or refresh.");
        setSaving(false);
      });


  };

  const handleClose = () => {
    setHide(true);
    close();
  };

  return (
    <div>
      <div onClick={handleClose} className="card-modal--overlay"></div>
      <div
        className={`card card-modal
          animate__animated
          animate__fadeInUp
          animate__faster
          ${hide ? "animate__fadeOutDown" : ""}
        `}
      >
        <div className="card-header flex-header">
          <h4 className="card-title">Note</h4>

          <div>
            <button
              onClick={handleClose}
              className="btn btn-outline-danger mr-1"
            >
              Cancel
            </button>

            <button
              onClick={handleSubmit}
              name="button"
              className="btn btn-primary"
            >
              {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
              Save
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <textarea
                className="form-control textarea-resizable"
                value={editingNote.content}
                onChange={(e) => {
                  const val = e.target.value;
                  setEditingNote((note) => {
                    return { ...note, content: val };
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NoteForm.propTypes = {
  note: PropTypes.object,
  updateNote: PropTypes.func,
  close: PropTypes.func,
};

export default NoteForm;
